export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
export const ROUTER_BASE = process.env.VUE_APP_ROUTER_BASE;